import { createAction, props } from '@ngrx/store';
import * as fromModel from '@shared/models';

const actionName = '[Dashboard]';

export const GET_DASHBOARD_DATA = createAction(
    `${actionName} Get dashboard data from the API`,
    props<{ searchQuery: any }>()
);
export const GET_DASHBOARD_DATA_SUCCESS = createAction(
    `${actionName} Get dashboard data from the API success`,
    props<{ dashData: any }>()
);
export const GET_DASHBOARD_DATA_FAIL = createAction(
    `${actionName} Get dashboard data from the API fail`,
    props<{ error: any }>()
);
